import React, { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const EditPencilIcon: FC<IconProps> = ({ width = 28, height = 28, stroke = '#737478', className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0003 9.33217L4.66699 18.6655V23.3322L9.33366 23.3321L18.667 13.9988M14.0003 9.33217L17.3471 5.9854L17.3491 5.98342C17.8098 5.52272 18.0405 5.29197 18.3065 5.20554C18.5408 5.1294 18.7933 5.1294 19.0276 5.20554C19.2934 5.29191 19.5239 5.5224 19.9839 5.98244L22.0137 8.01221C22.4757 8.47422 22.7068 8.70534 22.7934 8.97173C22.8695 9.20604 22.8695 9.45844 22.7934 9.69276C22.7069 9.95895 22.4761 10.1897 22.0147 10.6511L22.0137 10.6521L18.667 13.9988M14.0003 9.33217L18.667 13.9988"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
